import * as angular from 'angular';
import { DatasetLinkComponent } from './dataset-link.component';

export const DatasetLinkModule = angular.module('dataset-link', []).component('datasetLink', DatasetLinkComponent).name;
